<template>
  <page-list
    show-tag-columns
    show-tag-filter
    :list="list"
    :columns="columns"
    :group-actions="groupActions"
    :single-actions="singleActions"
    :export-data-options="exportDataOptions" />
</template>

<script>
import { mapGetters } from 'vuex'
import WindowsMixin from '@/mixins/windows'
import ListMixin from '@/mixins/list'
import { getSetPublicAction } from '@/utils/common/tableActions'
import SingleActionsMixin from '../mixins/singleActions'
import ColumnsMixin from '../mixins/columns'

export default {
  name: 'BastionHostList',
  mixins: [WindowsMixin, ListMixin, ColumnsMixin, SingleActionsMixin],
  props: {
    id: String,
    getParams: {
      type: Object,
    },
  },
  data () {
    return {
      list: this.$list.createList(this, {
        id: this.id,
        resource: 'bastion_hosts',
        getParams: this.getParam,
        filterOptions: {},
        hiddenColumns: ['access_key_id'],
      }),
      groupActions: [
        {
          label: this.$t('common_114'),
          permission: 'bastion_hosts_create',
          action: () => {
            this.createDialog('BastionCreateOrUpdateDialog', {
              success: () => {
                this.refresh()
              },
            })
          },
          meta: () => {
            return {
              buttonType: 'primary',
            }
          },
        },
        {
          label: this.$t('common.batchAction'),
          actions: () => {
            return [
              {
                label: this.$t('common_641', [this.$t('dictionary.project')]),
                action: () => {
                  this.createDialog('ChangeOwenrDialog', {
                    data: this.list.selectedItems,
                    columns: this.columns,
                    name: this.$t('bastionHost.title'),
                    onManager: this.onManager,
                    resource: 'bastion_hosts',
                  })
                },
                meta: () => {
                  const ret = {
                    validate: false,
                    tooltip: '',
                  }
                  if (this.isProjectMode) {
                    ret.tooltip = this.$t('bastionHost.user_permission_check', [this.$t('dictionary.domain')])
                    return ret
                  }
                  const isSomeShared = this.list.selectedItems.some(item => {
                    return item.is_public && item.public_scope !== 'none'
                  })
                  if (isSomeShared) {
                    ret.tooltip = this.$t('common_280')
                    return ret
                  }
                  const f = this.eachValidates((obj) => {
                    return this.isPower(obj)
                  })
                  return {
                    validate: f,
                  }
                },
              },
              getSetPublicAction(this, {
                name: this.$t('bastionHost.title'),
                scope: 'project',
                resource: 'bastion_hosts',
              }),
            ]
          },
          meta: () => {
            return {
              validate: this.list.selected.length,
            }
          },
        },
      ],
    }
  },
  computed: {
    ...mapGetters(['isAdminMode', 'isDomainMode', 'isProjectMode', 'userInfo']),
  },
  created () {
    this.list.fetchData()
  },
  methods: {
    eachValidates (callback) {
      let f = true
      if (this.list.selectedItems && this.list.selectedItems.length > 0) {
        for (let i = 0; i < this.list.selectedItems.length; i++) {
          const item = this.list.selectedItems[i]
          if (callback && !callback(item)) {
            f = false
            break
          }
        }
      } else {
        f = false
      }
      return f
    },
    isPower (obj) {
      if (this.isAdminMode) return true
      if (this.isDomainMode) return obj.domain_id === this.userInfo.projectDomainId
      return obj.tenant_id === this.userInfo.projectId
    },
    handleOpenSidepage (row) {
      this.sidePageTriggerHandle(this, 'BastionHostSidePage', {
        id: row.id,
        resource: 'bastion_hosts',
        getParams: this.getParam,
      }, {
        list: this.list,
      })
    },
    getParam () {
      const ret = {
        ...this.getParams,
        scope: this.$store.getters.scope,
        details: true,
      }
      return ret
    },
  },
}
</script>
